import React from "react";
import "./background.css";
import Reveal from "../motion/Reveal";

const education = [
  {
    school: "University of Swabi",
    degree: "Bachelor of Science — Computer Science",
    period: "Sep 2017 — Sep 2021",
    detail: "Grade: 2.98 / 4.0",
  },
  {
    school: "Peshawar Model Degree College (PMDC)",
    degree: "FSC, Pre-Engineering",
    period: "Aug 2015 — Sep 2017",
    detail: "Grade: A",
  },
];

const certifications = [
  {
    title: "React Native — The Practical Guide [2025]",
    org: "Udemy",
    issued: "Issued Aug 2025",
    id: "UC-f16bcf45-299a-448b-845b-d3661371a9c8",
  },
  {
    title: "Complete web development course",
    org: "Udemy",
    issued: "Credential issued",
    id: "UC-ed6f2c68-a569-4d8c-bfd3-524146dfa2a8",
  },
];

const Background = () => {
  return (
    <section id="background" className="section background">
      <div className="container">
        <Reveal>
          <p className="section__label">
            <span>05</span> — Background
          </p>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="section__title">
            Education, certifications, and the rooms I&apos;ve learned in.
          </h2>
        </Reveal>

        <div className="background__grid">
          <Reveal className="background__col">
            <h3>Education</h3>
            <ul>
              {education.map((item) => (
                <li key={item.school}>
                  <h4>{item.degree}</h4>
                  <p className="background__org">{item.school}</p>
                  <p className="mono background__period">{item.period}</p>
                  <p className="background__detail">{item.detail}</p>
                </li>
              ))}
            </ul>
          </Reveal>

          <Reveal className="background__col" delay={0.08}>
            <h3>Licenses & certifications</h3>
            <ul>
              {certifications.map((item) => (
                <li key={item.id}>
                  <h4>{item.title}</h4>
                  <p className="background__org">{item.org}</p>
                  <p className="mono background__period">{item.issued}</p>
                  <p className="background__detail">Credential ID {item.id}</p>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Background;
